import React from 'react';
import PropTypes from 'prop-types';

const ReplySnippet = ({ replyTo }) => {
    // 1. Normalize data
    const isObject = replyTo && typeof replyTo === 'object';

    // 2. Extract Name
    let senderName = 'User';
    if (isObject && replyTo.sender) {
        const s = replyTo.sender;
        senderName = s.username || s.name || (typeof s === 'string' ? s : 'User');
    }

    // 3. Extract Content Preview
    const contentPreview = isObject
        ? replyTo.content || '[Media Message]'
        : '[Original message not loaded]';

    // NOTE: We removed handleClick from here. 
    // The onClick is now handled by the parent div in MessageItem.js 
    // using the onJumpToMessage prop.

    return (
        <div className="message-reply-snippet-inner">
            <span className="reply-author">{senderName}:</span>{' '}
            <span className="reply-content">{contentPreview}</span>
        </div>
    );
};

ReplySnippet.propTypes = {
    replyTo: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            _id: PropTypes.string,
            id: PropTypes.string,
            sender: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            content: PropTypes.string,
        }),
    ]),
};

export default ReplySnippet;